import { render } from "./CalendarCardEvent.vue?vue&type=template&id=327bb962"
import script from "./CalendarCardEvent.vue?vue&type=script&lang=js"
export * from "./CalendarCardEvent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__